import { a as __extends, b as __awaiter, e as __generator, d as __assign, C as ClientSDKProxyContext } from '../../chunks/chunk-525a49bc.js';
import 'antd';
import React, { Component as Component$1 } from 'react';
import 'styled-components';
import { E as ERROR_NO_SDK_CLIENT, a as ERROR_API_UNEXPECTED_RESULTS } from '../../chunks/chunk-bc685b06.js';
import '../../chunks/chunk-53391a7d.js';
import '../../chunks/chunk-c2b06a8e.js';
import '../../chunks/chunk-6cec2b98.js';
import '../../chunks/chunk-2f6aabaf.js';
import '../../chunks/chunk-e1ac37a6.js';
import 'lodash';
import { C as Component } from '../../chunks/chunk-8a66acb9.js';
import 'uuid';

var defaultStrings = {
    searchPlaceholder: 'Search for an asset',
    emptyLiveSearch: 'Nothing found',
};
var AssetSearch = /** @class */ (function (_super) {
    __extends(AssetSearch, _super);
    function AssetSearch(props) {
        var _this = _super.call(this, props) || this;
        _this.generateSearchQuery = function (query) { return ({
            search: {
                name: query.query,
                description: (query.advancedSearch && query.advancedSearch.description) || undefined,
            },
            filter: {
                parentIds: query.assetSubtrees || undefined,
                metadata: (query.advancedSearch &&
                    query.advancedSearch.metadata &&
                    query.advancedSearch.metadata.reduce(function (a, c) {
                        var _a;
                        return (c.key ? __assign(__assign({}, a), (_a = {}, _a[c.key] = c.value, _a)) : a);
                    }, {})) ||
                    undefined,
            },
        }); };
        _this.state = {
            items: [],
            loading: false,
        };
        _this.onSearch = _this.onSearch.bind(_this);
        return _this;
    }
    AssetSearch.prototype.componentDidMount = function () {
        if (!this.context) {
            console.error(ERROR_NO_SDK_CLIENT);
            return;
        }
        this.client = this.context(AssetSearch.displayName || '');
        this.assetsApi = this.client.assets;
    };
    AssetSearch.prototype.onSearch = function (query) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, onError, onSearchResult, items, assetQuery, items, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, onError = _a.onError, onSearchResult = _a.onSearchResult;
                        if (!query.query && !query.advancedSearch) {
                            items = [];
                            this.setState({ items: items });
                            if (onSearchResult) {
                                onSearchResult(items);
                            }
                            return [2 /*return*/];
                        }
                        this.setState({ loading: true });
                        assetQuery = this.generateSearchQuery(query);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.assetsApi.search(assetQuery)];
                    case 2:
                        items = _b.sent();
                        if (!items || !Array.isArray(items)) {
                            console.error(ERROR_API_UNEXPECTED_RESULTS, items);
                            return [2 /*return*/];
                        }
                        this.setState({ items: items, loading: false });
                        if (onSearchResult) {
                            onSearchResult(items);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _b.sent();
                        if (onError) {
                            onError(e_1);
                        }
                        this.setState({ items: [], loading: false });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AssetSearch.prototype.render = function () {
        var _a = this.props, showLiveSearchResults = _a.showLiveSearchResults, rootAssetSelect = _a.rootAssetSelect, advancedSearch = _a.advancedSearch, strings = _a.strings, styles = _a.styles;
        var resultStrings = __assign(__assign({}, defaultStrings), strings);
        var _b = this.state, items = _b.items, loading = _b.loading;
        var onLiveSearchSelect = showLiveSearchResults
            ? this.props.onLiveSearchSelect
            : undefined;
        return (React.createElement(Component, { showLiveSearchResults: showLiveSearchResults, onSearch: this.onSearch, liveSearchResults: items, onLiveSearchSelect: onLiveSearchSelect, strings: resultStrings, loading: loading, rootAssetSelect: rootAssetSelect, advancedSearch: advancedSearch, styles: styles }));
    };
    AssetSearch.displayName = 'AssetSearch';
    AssetSearch.defaultProps = {
        rootAssetSelect: false,
        advancedSearch: false,
        showLiveSearchResults: true,
    };
    AssetSearch.contextType = ClientSDKProxyContext;
    return AssetSearch;
}(Component$1));

export { AssetSearch };
